import { Reducer } from 'redux';
import { DevicesTypes, DevicesState } from './types';

const INITIAL_STATE: DevicesState = {
  devicesList: [],
  deviceStatus: {
    total: 0,
    online: 0,
    offline: 0,
    devices: [],
  },
  deviceTimeline: {
    deviceId: '',
    from: '',
    to: '',
    totalHeartbeats: 0,
    timeline: [],
  },
  deviceData: {
    id: '',
    type: '',
    value: '',
    label: '',
    status: null,
    lastUsedAt: '',
    createdAt: '',
    updatedAt: '',
    userId: '',
  },
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<DevicesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST DEVICE
    case DevicesTypes.LIST_DEVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        deviceData: INITIAL_STATE.deviceData,
      };

    case DevicesTypes.LIST_DEVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        deviceData: action.payload.deviceData,
        totalCount: action.payload.totalCount,
      };

    case DevicesTypes.LIST_DEVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        deviceData: INITIAL_STATE.deviceData,
      };

    // CASES LIST DEVICES
    case DevicesTypes.LIST_DEVICES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        devicesList: INITIAL_STATE.devicesList,
      };

    case DevicesTypes.LIST_DEVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        devicesList: action.payload.devicesList,
        totalCount: action.payload.totalCount,
      };

    case DevicesTypes.LIST_DEVICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        devicesList: INITIAL_STATE.devicesList,
      };

    // CASES LIST DEVICE STATUS
    case DevicesTypes.LIST_DEVICE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        deviceStatus: INITIAL_STATE.deviceStatus,
      };

    case DevicesTypes.LIST_DEVICE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        deviceStatus: action.payload.deviceStatus,
      };

    case DevicesTypes.LIST_DEVICE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        deviceStatus: INITIAL_STATE.deviceStatus,
      };

    // CASES LIST DEVICE TIMELINE
    case DevicesTypes.LIST_DEVICE_TIMELINE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        deviceTimeline: INITIAL_STATE.deviceTimeline,
      };

    case DevicesTypes.LIST_DEVICE_TIMELINE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        deviceTimeline: action.payload.deviceTimeline,
      };

    case DevicesTypes.LIST_DEVICE_TIMELINE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        deviceTimeline: INITIAL_STATE.deviceTimeline,
      };

    default:
      return state;
  }
};

export default reducer;
